var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Panel',{staticClass:"overflow-hidden battle-royale-results-table px-0",attrs:{"variant":[
    'transparent',
    'stroked',
    'stroked-input-borders',
    'rounded',
    'half-paddings' ]}},[_c('div',{staticClass:"col"},[_c('Table',{attrs:{"columns":_vm.columns,"items":_vm.sortedResults,"dummy-props":{
        iconName: 'dummy/members',
        size: 320,
        headerText: _vm.$$t('There are no participants yet', 'list-empty-state'),
        text: _vm.$$t('', 'list-empty-state_subheader'),
      }},scopedSlots:_vm._u([{key:"head-item",fn:function(ref){
      var column = ref.column;
return _c('div',{staticClass:"d-flex w-100 align-items-center",class:[
          {
            'cursor-pointer': column.sort,
          },
          column.key === 'participants'
            ? 'justify-content-start'
            : 'justify-content-center' ]},[_c('TextBlock',{attrs:{"size":0.75,"line-height":1.4,"variant":"secondary"}},[_vm._v("\n          "+_vm._s(_vm.$t(
              ("_web_competitions_tournaments-list_col-title-" + (column.key)),
              column.label
            ))+"\n        ")])],1)}},{key:"body-item",fn:function(ref){
            var item = ref.item;
            var key = ref.column.key;
            var index = ref.index;
return [(key === 'number')?[_c('TextBlock',{attrs:{"text":1 + index}})]:_vm._e(),(key === 'participants')?[_c('PlayersTableUsernameCell',{key:_vm.$filters.displayName(_vm.playerProfile(item).profile),attrs:{"account":_vm.playerProfile(item).profile,"is-clan":_vm.playerProfile(item).profile.type === 'clan'}})]:_c('TextBlock',{attrs:{"text":item[key]}})]}}])})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }